import CustomTooltip from './CustomTooltip.vue';
export default {
  name: "RadioSatisfyQuestionnaire",
  components: {
    CustomTooltip
  },
  props: {
    hints: {
      type: Array,
      default: () => []
    },
    others: {},
    formValues: Array,
    questionIndex: Number
  },
  data: () => ({
    shortV: [],
    selectedOptionI: null
  }),
  computed: {
    // shortV(){
    //     return self.hints
    // }
  },
  methods: {
    onSelect(optionIndex) {
      this.selectedOptionI = optionIndex;
      this.$emit("update-value", this.questionIndex, this.hints.length - optionIndex);
    }
  },
  watch: {
    hints: {
      handler(nV) {
        // console.log('sdfsdf"', nV)
      },
      deep: true
    },
    selectedOptionI(nV) {}
  },
  created() {
    // console.log(2222, self.hints)
  }
};